import {ChronologicalCommentsSort, isChronologicalCommentsSort} from '@github-ui/commenting/ChronologicalCommentsSort'
import {sendEvent} from '@github-ui/hydro-analytics'
import {useLocalStorage} from '@github-ui/use-safe-storage/local-storage'
import {useCallback} from 'react'

export const ISSUE_COMMENTS_SORT_STORAGE_KEY = 'issue-comments-sort'

/** Always oldest first unless the issue is showing the comments feed. */
export function useIssueCommentsSort(enabled: boolean) {
  const [savedSort, setSavedSort] = useLocalStorage<ChronologicalCommentsSort>(
    ISSUE_COMMENTS_SORT_STORAGE_KEY,
    ChronologicalCommentsSort.OldestFirst,
    {validator: isChronologicalCommentsSort},
  )

  const setSort = useCallback(
    (next: ChronologicalCommentsSort) => {
      // Picking the current sort again isn't a change.
      if (next === savedSort) return
      setSavedSort(next)
      sendEvent('issue_viewer.comments.sort_changed', {sort: next})
    },
    [savedSort, setSavedSort],
  )

  return {sort: enabled ? savedSort : ChronologicalCommentsSort.OldestFirst, setSort}
}
